import type { IconSvgObject } from './types';

const Gif01Icon: IconSvgObject = [
  ["path", { d: "M8 17V16H4V22H8V19.5H6.66667M11 16H12.5M12.5 16H14M12.5 16V22M11 22H12.5M12.5 22H14M20 16H17V19M17 19V22M17 19H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 13L4.01355 3.99919C4.01522 2.89493 4.91151 2.00097 6.01578 2.0022L12.9924 2.00996L20 8.997V13M12.9966 2.49998V6.99998C12.9966 8.10455 13.892 8.99998 14.9966 8.99998H19.4998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Gif01Icon;
